import Blue from "~/core";

new Blue({
  name: "Header Nav Menu",
  selector: ".header",
  setup(header) {
    const backdrop = header.querySelector(".header__backdrop");
    const logo = header.querySelector(".header__drawer-header");
    const scheduledService = header
      .querySelector(".schedule-services-btn")
      .closest("li");
    const util = header.querySelector(".header__util");
    const utilMenus = [...util.querySelectorAll(".util__primary-item--sub")];
    const utilClose = [...util.querySelectorAll(".util__secondary-close")];
    const nav = header.querySelector(".header__nav");
    const primaryMenu = nav != null ? nav.querySelector(".nav__primary") : null;
    const primaryItems =
      nav != null ? [...nav.querySelectorAll(".nav__primary-item")] : [];
    const search = header.querySelector(".header__search");
    const searchToggle = search.querySelector(".search__toggle");
    const drawer = header.querySelector(".header__drawer");
    const drawerToggle = header.querySelector(".header__toggle");
    const searchBox = search.querySelector(".search__input");
    const searchButton = search.querySelector(".search__submit");
    const alert = header.querySelector(".alert");
    let lastPos = 0;

    const content = document.getElementById("content");
    content.style.paddingTop = `${header.offsetHeight}px`;

    const headerIsActive = () =>
      !![...header.querySelectorAll(".is-active, .is-open")].length;

    // const handleHeaderDisplay = () => {
    // 	content.style.paddingTop = `${header.offsetHeight}px`;
    // 	if (window.scrollY > header.offsetHeight) {
    // 		let currPos = document.documentElement.scrollTop || document.body.scrollTop; // Get Current Scroll Value

    // 		if (currPos > 0 && lastPos <= currPos){
    // 			lastPos = currPos;
    // 			// console.log('hidden');
    // 			header.classList.add('is-hidden');
    // 		}else{
    // 			lastPos = currPos;
    // 			// console.log('revealed');
    // 			header.classList.remove('is-hidden');
    // 		}
    // 	}
    // }

    const displayBackdrop = e => {
      let isMobile = window.innerWidth <= 991;
      let offset = header.offsetHeight;
      if (!isMobile) {
        if (
          e &&
          e.classList.contains("util__primary-item") &&
          e.classList.contains("is-active")
        ) {
          offset = e.offsetHeight;
          backdrop.style.top = `calc(100% - ${offset}px`;
        } else if (
          e &&
          e.classList.contains("nav__primary-item") &&
          e.classList.contains("is-active")
        ) {
          backdrop.style.top = "100%";
        }
      }

      backdrop.style.height = `${window.innerHeight - offset}px`;
      if (headerIsActive()) {
        backdrop.classList.add("is-visible");
        return;
      }
      backdrop.classList.remove("is-visible");
    };

    const closeAllMenus = e => {
      if (e) {
        let inNav = e.target.closest(".header__nav");
        let inUtil = e.target.closest(".util__secondary");
        let inSearch = e.target.closest(".header__search");
        let inDrawer = e.target.closest(".header__drawer");
        if (inUtil || inNav || inSearch || inDrawer) return;
      }

      document.body.classList.remove("no-scroll");
      let activeMenus = [...header.querySelectorAll(".is-active, .is-open")];
      activeMenus.forEach(active =>
        active.classList.remove("is-active", "is-open")
      );
      displayBackdrop();
    };

    const toggleDrawer = () => {
      let activeMenus = [...header.querySelectorAll(".is-active")];

      if (activeMenus.length) {
        activeMenus.forEach(active => active.classList.remove("is-active"));
        displayBackdrop();
      }
      document.body.classList.toggle("no-scroll");
      drawerToggle.classList.toggle("is-open");
      drawer.classList.toggle("is-open");
      if (alert) {
        drawer.style.top = `${header.offsetHeight}px`;
      } else {
        drawer.style.top = `${header.offsetHeight}px`;
      }
      if (!drawer.classList.contains("is-open")) {
        closeAllMenus();
      } else {
      }
      displayBackdrop();
    };

    const resizeUtilityNavDropdowns = () => {
      let isMobile = window.innerWidth <= 991;

      var navDropdowns = document.querySelectorAll(
        "li.util__primary-item.util__primary-item--sub > ul"
      );

      navDropdowns.forEach(navDropdown => {

        if (isMobile) {
          navDropdown.style.maxHeight = "none";
          return;
        }

        navDropdown.style.maxHeight = `${window.innerHeight -
          navDropdown.getBoundingClientRect().top -
          10}px`;
      });
    };

    const bindNavEvents = (
      item,
      trigger,
      blurTrigger = false,
      isUtility = false
    ) => {
      if (trigger) {
        let isMobile = window.innerWidth <= 991;

        this.$addEvents(
          trigger,
          "click.stop.prevent enter.stop.prevent space.stop.prevent",
          e => {
            if (drawerToggle.classList.contains("is-open")) {
              document.body.classList.add("no-scroll");
            } else {
              document.body.classList.remove("no-scroll");
            }
            search.classList.remove("is-active");
            util.classList.remove("is-active");
            nav.classList.remove("is-active");
            item.classList.toggle("is-active");

            if (!item.classList.contains("is-active")) {
              let activeChildren = [...item.querySelectorAll(".is-active")];
              activeChildren.forEach(i => i.classList.remove("is-active"));
            } else {
              let menu = item.closest("ul");
              let activeSiblings = [
                ...menu.querySelectorAll(".is-active")
              ].filter(s => s !== item);
              activeSiblings.forEach(sib => sib.classList.remove("is-active"));

              if (!item.classList.contains("util__primary-item--sub")) {
                utilMenus.forEach(i => i.classList.remove("is-active"));
                util.classList.add("is-active");
                nav.classList.add("is-active");
              } else {
                if (isMobile && item.classList.contains("is-active")) {
                  document.body.classList.add("no-scroll");
                }
                primaryItems.forEach(i => i.classList.remove("is-active"));
                util.classList.remove("is-active");
                nav.classList.remove("is-active");
                if (!isUtility) {
                  drawerToggle.classList.remove("is-open");
                  drawer.classList.remove("is-open");
                }
              }
            }
            displayBackdrop(item);
          }
        );
      }

      if (blurTrigger) {
        this.$addEvents(blurTrigger, "focusout.stop", () => {
          if (this.$screen.lg.matches) {
            if (!item.matches(":focus-within")) {
              item.classList.remove("is-active");
            }
          }
          displayBackdrop();
        });
        this.$addEvents(blurTrigger, "escape.stop", () => {
          item.classList.remove("is-active");
          displayBackdrop();
        });
      }

      this.$addEvents(window, "resize", resizeUtilityNavDropdowns);
      this.$addEvents(window, "load", resizeUtilityNavDropdowns);
    };
    //
    const bindSearchEvents = () => {
      let inner = search.querySelectorAll(".search__inner");
      let input = search.querySelector(".search__input");
      this.$addEvents(
        searchToggle,
        "click.stop.prevent enter.stop.prevent space.stop.prevent",
        () => {
          let activeMenus = [...nav.querySelectorAll(".is-active")];
          activeMenus.forEach(active => active.classList.remove("is-active"));
          drawer.classList.remove("is-open");
          drawerToggle.classList.remove("is-open");
          search.classList.toggle("is-active");
          document.body.classList.toggle("no-scroll");
          displayBackdrop(search);
        }
      );

      this.$addEvents(search, "focusout.stop", () => {
        if (
          !search.matches(":focus-within") &&
          !document.body.classList.contains("using-mouse")
        ) {
          search.classList.remove("is-active");
        }
        displayBackdrop();
      });

      this.$addEvents(searchBox, "keyup", e => {
        if (e.keyCode == 13) {
          doSearch();
        }
      });

      this.$addEvents(searchButton, "click", e => {
        doSearch();
      });

      this.$addEvents(search, "escape.stop", () => {
        search.classList.remove("is-active");
        displayBackdrop();
      });

      this.$addEvents(inner, "transitionend.self.stop.prevent", e => {
        if (e.propertyName === "visibility") {
          if (search.classList.contains("is-active")) {
            input.focus();
          }
        }
        displayBackdrop();
      });

      const doSearch = () => {
        if (window.location.href.toLowerCase().includes("en-us")) {
          window.location.href = `/en-us/search?q=${searchBox.value}`;
        } else if (window.location.href.toLowerCase().includes("en-ca")) {
          window.location.href = `/en-ca/search?q=${searchBox.value}`;
        } else if (window.location.href.toLowerCase().includes("fr-ca")) {
          window.location.href = `/fr-ca/search?q=${searchBox.value}`;
        } else {
          window.location.href = `/search?q=${searchBox.value}`;
        }

        search.classList.toggle("is-active");
      };
    };

    const initMobile = () => {
      this.$retach(primaryMenu, {
        destination: ".drawer__nav",
        mediaQuery: this.$screen.lg_dn
      });
      this.$retach(util, {
        destination: ".drawer__nav",
        mediaQuery: this.$screen.lg_dn
      });
      this.$retach(logo, {
        destination: ".header__inner",
        mediaQuery: this.$screen.lg_dn
      });
       this.$retach(scheduledService, {
         destination: ".header__inner",
         mediaQuery: this.$screen.lg_dn
       });

      this.$addEvents(
        drawerToggle,
        "click.stop.prevent enter.stop.prevent space.prevent",
        toggleDrawer
      );
      this.$addEvents(
        utilClose,
        "click.stop.prevent enter.stop.prevent space.prevent",
        () => {
          closeAllMenus(false);
        }
      );
    };

    primaryItems.forEach(item => {
      let trigger = item.querySelectorAll(
        ".nav__primary-label, .nav__secondary-back"
      );
      let blurTrigger = item.querySelector(".nav__secondary");
      bindNavEvents(item, trigger, blurTrigger);
    });

    utilMenus.forEach(item => {
      let trigger = item.querySelectorAll(".util__primary-label");
      let blurTrigger = item.querySelector(".util__secondary");
      bindNavEvents(item, trigger, blurTrigger, true);
    });

    bindSearchEvents();
    initMobile();

    this.$addEvents(document, "click", closeAllMenus);
    //window.addEventListener('scroll', handleHeaderDisplay);
  }
});
